export default {
    title: `My other social media accounts`,
    subTitle: `Statistics for the following social media account(s) not available at the moment.`,
    edit: `Add or edit my social media accounts`,
    add: `Add my other social media accounts`,
};
